// import React, { useState, useEffect } from "react";
// import { useParams, useHistory } from "react-router-dom";
// import "./ruleDetails.css";
// import logoBlue from "../../components/images/logoblue.png";
// import { Delete, Edit, Check, Sync, ArrowBack } from "@material-ui/icons";
// import { updateRule } from "../../services/game.services.js";
// import { getRules } from "../../services/game.services.js";
// import { getOneRule } from "../../services/game.services.js";

// export default function RuleDetails(props) {
//   const initialState = {
//     id: "",
//     ruleName: "",
//     ruleId: "",
//     gender: "",
//     gamePeriods: "",
//     periodDuration: "",
//     gapBetweenPeriods: "",
//     gapBetweenHalves: "",
//     timeoutsPerHalf: "",
//     timeoutsInOvertimePeriod: "",
//     maxOvertimePeriods: "",
//     overtimePeriodDuration: "",
//     goalDiffForRunningClock: "",
//     maxPersonalFouls: "",
//     maxFOViolationPerHalf: "",
//   };

//   const [initialStateForm, setInitialStateForm] = useState(initialState);
//   const [editable, setEditable] = useState(false);
//   const [isVisible, setIsVisible] = useState(false);
//   const [ruleData, setRuleData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [ruleDetailsloading, setRuleDetailsLoading] = useState(false);

//   const { ruleId } = useParams();

//   const toggleDelete = () => {
//     setIsVisible(!isVisible);
//   };

//   const toggleEdit = () => {
//     setEditable(!editable);
//   };

//   const handleFormChange = (name, value) => {
//     setInitialStateForm((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     console.log("val", initialStateForm);

 
//     try {
//       setLoading(true);
//       const response = await updateRule(
//         initialStateForm,
//         JSON.parse(sessionStorage.getItem("myData"))
//       );
//       console.log("editRule request workingggggg", response.data);
//       setEditable(!editable);
//     } catch (e) {
//       console.log("errorrrrrrr in api", e?.message);
//     } finally {
//       setLoading(false);
//     }
//   };

 

//   useEffect(() => {
//     const fnt = async () => {
//       try {
//         setRuleDetailsLoading(true);
//         const response = await getOneRule(
//           ruleId,
//           JSON.parse(sessionStorage.getItem("myData"))
//         );
//         setRuleData(response.data);
//         let data = response.data;
//         data = { ...data, id: response.data._id };

//         delete data.__v;
//         delete data._id;


//         setInitialStateForm(data);
        
//       } catch (error) {
//         console.log("errorrrrrrr in rule detailsssss", error);
//       } finally {
//         setRuleDetailsLoading(false);
//       }
//     };
//     fnt();
//   }, []);

//   // Function to convert decimal minutes to MM:SS format
//   const formatMinutesToMMSS = (decimalMinutes) => {
//     const totalSeconds = Math.round(decimalMinutes * 60);
//     const minutes = Math.floor(totalSeconds / 60);
//     const seconds = totalSeconds % 60;
//     return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
//       2,
//       "0"
//     )}`;
//   };

//   // Function to convert MM:SS format to decimal minutes
//   const parseMMSSToMinutes = (mmss) => {
//     const [minutes, seconds] = mmss.split(":").map(Number);
//     const totalMinutes = minutes + seconds / 60;
//     return parseFloat(totalMinutes.toFixed(2));
//   };

//   useEffect(() => {
//     console.log("**", editable);
//   }, [editable]);

//   let history = useHistory();

//   return (
//     <div className="ruleDetails">
//       <div className="ruleDetailsHeader">
//         <div className="titleWithBack">
//           <button className="backBtn" onClick={() => history.goBack()}>
//             <ArrowBack className="backBtnIcon" />
//           </button>
//           <h1 className="ruleDetailsTitle">Rule Details</h1>
//         </div>
//         <div className="toEditBtns">
//           <button onClick={toggleDelete} className="deleteBtn">
//             <Delete className="deleteBtnIcon" />
//           </button>
//           {!editable ? (
//             <button onClick={toggleEdit} className="editBtn">
//               <Edit className="editBtnIcon" />
//             </button>
//           ) : (
//             <button onClick={handleUpdate} className="editBtn">
//               {loading ? <Sync /> : <Check className="editBtnIcon" />}
//             </button>
//           )}
//         </div>
//         <img
//           className="ruleDetailsLogo"
//           src={logoBlue}
//           alt="logo"
//           width="150px"
//         ></img>
//       </div>
//       <h1 className="ruleName">{ruleData?.ruleName}</h1>
//       <div className="view2Div">
//         <button className="view2Btn1">Rule: {ruleData?.ruleId}</button>
//         <button className="view2Btn2">Gender: {ruleData?.gender}</button>
//       </div>
//       <div className="ruleView">
//         <h4 className="genTxt">Periods Per Game :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={ruleData?.gamePeriods}
//             onChange={(e) =>
//               handleFormChange("gamePeriods", parseInt(e.target.value))
//             }
//           />
//         ) : (
//           <input
     
//             className="input"
//             value={initialStateForm?.gamePeriods.toString()}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Minutes per Period :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={formatMinutesToMMSS(ruleData?.periodDuration)}
//             onChange={(e) =>
//               handleFormChange(
//                 "periodDuration",
//                 parseMMSSToMinutes(e.target.value)
//               )
//             }
//           />
//         ) : (
//           <input
//             className="input"
//             value={formatMinutesToMMSS(initialStateForm?.periodDuration)}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Minutes Between Periods :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={formatMinutesToMMSS(ruleData?.gapBetweenPeriods)}
//             onChange={(e) =>
//               handleFormChange("gapBetweenPeriods", parseMMSSToMinutes(e.target.value))
//             }
//           />
//         ) : (
//           <input
      
//             className="input"
//             value={formatMinutesToMMSS(initialStateForm?.gapBetweenPeriods)}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Minutes Between Halves :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={formatMinutesToMMSS(ruleData?.gapBetweenHalves)}
//             onChange={(e) =>
//               handleFormChange("gapBetweenHalves", parseMMSSToMinutes(e.target.value))
//             }
//           />
//         ) : (
//           <input
         
//             className="input"
//             value={formatMinutesToMMSS(initialStateForm?.gapBetweenHalves)}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Timeout per Half :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={ruleData?.timeoutsPerHalf.toString()}
//             onChange={(e) =>
//               handleFormChange("timeoutsPerHalf", parseInt(e.target.value))
//             }
//           />
//         ) : (
//           <input
        
//             className="input"
//             value={initialStateForm?.timeoutsPerHalf.toString()}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Timeouts in Overtime :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={ruleData?.timeoutsInOvertimePeriod.toString()}
//             onChange={(e) =>
//               handleFormChange(
//                 "timeoutsInOvertimePeriod",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         ) : (
//           <input
      
//             className="input"
//             value={initialStateForm?.timeoutsInOvertimePeriod.toString()}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">No. of Overtime Periods :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={ruleData?.maxOvertimePeriods.toString()}
//             onChange={(e) =>
//               handleFormChange("maxOvertimePeriods", parseInt(e.target.value))
//             }
//           />
//         ) : (
//           <input
       
//             className="input"
//             value={initialStateForm?.maxOvertimePeriods.toString()}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Minutes Per Overtime Periods :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={formatMinutesToMMSS(ruleData?.overtimePeriodDuration)}
//             onChange={(e) =>
//               handleFormChange(
//                 "overtimePeriodDuration",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         ) : (
//           <input
     
//             className="input"
//             value={formatMinutesToMMSS(initialStateForm?.overtimePeriodDuration)}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Goal Differential for running clock :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={ruleData?.goalDiffForRunningClock.toString()}
//             onChange={(e) =>
//               handleFormChange(
//                 "goalDiffForRunningClock",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         ) : (
//           <input
 
//             className="input"
//             value={initialStateForm?.goalDiffForRunningClock.toString()}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Max # Of Personal Fouls :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={ruleData?.maxPersonalFouls.toString()}
//             onChange={(e) =>
//               handleFormChange("maxPersonalFouls", parseInt(e.target.value))
//             }
//           />
//         ) : (
//           <input
      
//             className="input"
//             value={initialStateForm?.maxPersonalFouls.toString()}
//           />
//         )}
//       </div>

//       <div className="ruleView">
//         <h4 className="genTxt">Max # Of FO Violations Per Half :</h4>
//         {editable ? (
//           <input
//             className="input"
//             defaultValue={ruleData?.maxFOViolationPerHalf.toString()}
//             onChange={(e) =>
//               handleFormChange(
//                 "maxFOViolationPerHalf",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         ) : (
//           <input

//             className="input"
//             value={initialStateForm?.maxFOViolationPerHalf.toString()}
//           />
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './ruleDetails.css';
import logoBlue from '../../components/images/logoblue.png';
import { Delete, Edit, Check, Sync, ArrowBack } from '@material-ui/icons';
import { fetchRule, updateRuleDetails } from '../../redux/actions//ruleDetailsAction.js';

export default function RuleDetails() {
  const dispatch = useDispatch();
  const { ruleId } = useParams();
  const history = useHistory();

  const { ruleData, loading } = useSelector((state) => state.ruleDetails);

  const initialState = {
    id: '',
    ruleName: '',
    ruleId: '',
    gender: '',
    gamePeriods: '',
    periodDuration: '',
    gapBetweenPeriods: '',
    gapBetweenHalves: '',
    timeoutsPerHalf: '',
    timeoutsInOvertimePeriod: '',
    maxOvertimePeriods: '',
    overtimePeriodDuration: '',
    goalDiffForRunningClock: '',
    maxPersonalFouls: '',
    maxFOViolationPerHalf: '',
  };

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [editable, setEditable] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchRule(ruleId));
  }, [dispatch, ruleId]);

  useEffect(() => {
    if (ruleData) {
      const data = { ...ruleData, id: ruleData._id };
      delete data.__v;
      delete data._id;
      setInitialStateForm(data);
    }
  }, [ruleData]);

  const toggleDelete = () => {
    setIsVisible(!isVisible);
  };

  const toggleEdit = () => {
    setEditable(!editable);
  };

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    dispatch(updateRuleDetails(initialStateForm));
    setEditable(!editable);
  };

  const formatMinutesToMMSS = (decimalMinutes) => {
    const totalSeconds = Math.round(decimalMinutes * 60);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const parseMMSSToMinutes = (mmss) => {
    const [minutes, seconds] = mmss.split(':').map(Number);
    const totalMinutes = minutes + seconds / 60;
    return parseFloat(totalMinutes.toFixed(2));
  };

  return (
    <div className="ruleDetails">
      <div className="ruleDetailsHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="ruleDetailsTitle">Rule Details</h1>
        </div>
        <div className="toEditBtns">
          <button onClick={toggleDelete} className="deleteBtn">
            <Delete className="deleteBtnIcon" />
          </button>
          {!editable ? (
            <button onClick={toggleEdit} className="editBtn">
              <Edit className="editBtnIcon" />
            </button>
          ) : (
            <button onClick={handleUpdate} className="editBtn">
              {loading ? <Sync /> : <Check className="editBtnIcon" />}
            </button>
          )}
        </div>
        <img className="ruleDetailsLogo" src={logoBlue} alt="logo" width="150px" />
      </div>
      <h1 className="ruleName">{ruleData?.ruleName}</h1>
      <div className="view2Div">
        <button className="view2Btn1">Rule: {ruleData?.ruleId}</button>
        <button className="view2Btn2">Gender: {ruleData?.gender}</button>
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Periods Per Game :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={ruleData?.gamePeriods}
            onChange={(e) => handleFormChange('gamePeriods', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={initialStateForm?.gamePeriods.toString()} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Minutes per Period :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={formatMinutesToMMSS(ruleData?.periodDuration)}
            onChange={(e) => handleFormChange('periodDuration', parseMMSSToMinutes(e.target.value))}
          />
        ) : (
          <input className="input" value={formatMinutesToMMSS(initialStateForm?.periodDuration)} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Minutes Between Periods :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={formatMinutesToMMSS(ruleData?.gapBetweenPeriods)}
            onChange={(e) => handleFormChange('gapBetweenPeriods', parseMMSSToMinutes(e.target.value))}
          />
        ) : (
          <input className="input" value={formatMinutesToMMSS(initialStateForm?.gapBetweenPeriods)} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Minutes Between Halves :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={formatMinutesToMMSS(ruleData?.gapBetweenHalves)}
            onChange={(e) => handleFormChange('gapBetweenHalves', parseMMSSToMinutes(e.target.value))}
          />
        ) : (
          <input className="input" value={formatMinutesToMMSS(initialStateForm?.gapBetweenHalves)} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Timeout per Half :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={ruleData?.timeoutsPerHalf.toString()}
            onChange={(e) => handleFormChange('timeoutsPerHalf', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={initialStateForm?.timeoutsPerHalf.toString()} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Timeouts in Overtime :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={ruleData?.timeoutsInOvertimePeriod.toString()}
            onChange={(e) => handleFormChange('timeoutsInOvertimePeriod', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={initialStateForm?.timeoutsInOvertimePeriod.toString()} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">No. of Overtime Periods :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={ruleData?.maxOvertimePeriods.toString()}
            onChange={(e) => handleFormChange('maxOvertimePeriods', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={initialStateForm?.maxOvertimePeriods.toString()} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Minutes Per Overtime Periods :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={formatMinutesToMMSS(ruleData?.overtimePeriodDuration)}
            onChange={(e) => handleFormChange('overtimePeriodDuration', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={formatMinutesToMMSS(initialStateForm?.overtimePeriodDuration)} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Goal Differential for running clock :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={ruleData?.goalDiffForRunningClock.toString()}
            onChange={(e) => handleFormChange('goalDiffForRunningClock', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={initialStateForm?.goalDiffForRunningClock.toString()} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Max # Of Personal Fouls :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={ruleData?.maxPersonalFouls.toString()}
            onChange={(e) => handleFormChange('maxPersonalFouls', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={initialStateForm?.maxPersonalFouls.toString()} readOnly />
        )}
      </div>
      <div className="ruleView">
        <h4 className="genTxt">Max # Of FO Violations Per Half :</h4>
        {editable ? (
          <input
            className="input"
            defaultValue={ruleData?.maxFOViolationPerHalf.toString()}
            onChange={(e) => handleFormChange('maxFOViolationPerHalf', parseInt(e.target.value))}
          />
        ) : (
          <input className="input" value={initialStateForm?.maxFOViolationPerHalf.toString()} readOnly />
        )}
      </div>
    </div>
  );
}